import * as React from "react";
import Timestamp from "components/common/Timestamp";
import entityLinkResolvers from "components/common/markdown/entityLinkResolvers";
const pluginExports = {
  "markdown.augment.components": [
    {
      id: "ts",
      component: ({ value }) => /* @__PURE__ */ React.createElement("strong", null, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: value }))
    }
  ],
  "markdown.entityLinkResolvers": entityLinkResolvers
};
export default pluginExports;
